import { MessageErrorCustom } from "./styled";

export default function MessageError({ children, style }) {
  return (
    <MessageErrorCustom style={{ ...style }}>{children}</MessageErrorCustom>
  );
}
